import { Chip, Divider, Paper, Stack, Typography } from "@mui/material";
import { AccountScoreLevelDefinition } from "../../../api/psc";
import { separateByComma } from "../../../utils/string";
import { buyerSvg } from "../svgs/buyerSvg";
import fanSvg from "../svgs/fanSvg";
import loyalSvg from "../svgs/loyalSvg";
import persistentSvg from "../svgs/persistentSvg";

const GROUPS = {
    buyer: "خریدار",
    fan: "طرفدار",
    loyal: "وفادار",
    persistent: "ماندگار",
};

export default function ScoreDefinitionItem(props: {
    item: AccountScoreLevelDefinition;
}) {
    const getSvg = (svgName: string) => {
        switch (svgName) {
            case GROUPS.buyer:
                return buyerSvg();
            case GROUPS.fan:
                return fanSvg();
            case GROUPS.loyal:
                return loyalSvg();
            case GROUPS.persistent:
                return persistentSvg();
            default:
                break;
        }
    };
    return (
        <Paper key={props.item.displayName} sx={{ p: 2, width: "100%" }}>
            <Stack spacing={2} alignItems="center">
                {getSvg(props.item.displayName)}

                {props.item.imageUrl && (
                    <img src={props.item.imageUrl} width={65} height={65} />
                )}

                <Typography color="primary">
                    {props.item.displayName}
                </Typography>

                <Typography color="secondary">
                    حداقل امتیاز: {separateByComma(props.item.score.toString())}
                </Typography>

                <Divider flexItem />

                <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography color="text.secondary">تخفیف اشتراک</Typography>
                    <Chip
                        label={`${props.item.accountDiscount}%`}
                        size="small"
                    />
                </Stack>

                <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography color="text.secondary">تخفیف پیامک</Typography>
                    <Chip label={`${props.item.smsDiscount}%`} size="small" />
                </Stack>
            </Stack>
        </Paper>
    );
}
